import { useQuery } from "@tanstack/react-query"
import { AxiosResponse, create } from "axios"
import { config } from "~/config.ts"
import { axiosGet, handleRequestError } from "~/lib"
import { queryKeys } from "~/services/query-keys.ts"
import { User } from "~/types"

type SessionResponse = {
  user: User
}

// Create an axios instance without the auth interceptor
const axiosAuthInstance = create({
  baseURL: config.authBackendForFrontend,
  withCredentials: true,
})

axiosAuthInstance.defaults.headers["X-Client-Id"] = config.clientId

axiosAuthInstance.interceptors.response.use(
  (response) => response,
  (error) => handleRequestError(error, { skipAuthErrors: true })
)

export async function getSession(): Promise<User | null> {
  const { data } = await axiosGet<AxiosResponse<SessionResponse>>({
    url: "/auth/session",
    instance: axiosAuthInstance,
  })

  return data.user
}

export const useAuthSession = () => {
  return useQuery<User | null, Error>({
    queryKey: queryKeys.authSession(),
    queryFn: () => getSession(),
    staleTime: Infinity,
    retry: false,
  })
}
